import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { User } from '../../shared/entities/user';
import { UserService } from '../../shared/services/user.service';
import { MatChipsModule } from '@angular/material/chips';
import { UserMenuComponent } from '../../components/user-menu/user-menu.component';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [MatChipsModule, UserMenuComponent, RouterModule,MatIconModule],
  providers: [MeasurementsDataService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  units = [{ selected: false, name: 'Metric', value: 'METRIC', index: 0 }, { selected: false, name: 'Imperial', value: 'US_CUSTOMARY_UNITS', index: 1 }];
  userProfileUnit: string = '';
  selectedUnit: { selected: boolean, name: string, value: string, index: number } = { selected: false, name: 'Metric', value: 'METRIC', index: 0 };
  userData: User = {};
  userRole:any;
 platform:any;
  constructor(private userService: UserService, private toastr: ToastrService, private measurementsDataService: MeasurementsDataService , private router:Router) {}

  ngOnInit(): void {
    this.gettingUserProfileData();
  }

  gettingUserProfileData() {
    this.userRole=null;
          this.platform=null;
    this.userService.getProfile()
    .subscribe(profile => {
      this.userData = profile;
      if(profile){
        this.userRole=profile?.portalRoles;
         this.platform=profile?.subscribedPlatforms;
        localStorage.setItem("platform",this.platform);
        localStorage.setItem("role",this.userRole);
      }
     
      if(profile?.measurementSystem) 
      {
        let nameoFmes='';
        this.userProfileUnit = profile?.measurementSystem;
        this.units.forEach(elem=>{
          if(elem.value==this.userProfileUnit){
            nameoFmes=elem.name;
          }
        })
        this.selectedUnit={ selected: true, name: nameoFmes, value:  this.userProfileUnit, index: 0 }
        this.measurementsDataService.setData(profile?.measurementSystem);
      }
      this.units.forEach((item => {
        if(item.value === this.userProfileUnit) {
          item.selected = true;
        }
      }));
    });
  }

  unitSelected(unit: { selected: boolean, name: string, value: string, index: number }, ind: number) {
    this.units[ind].selected = true; 
    this.units.forEach(item => {
      if(unit.index != item.index){
        item.selected = false;
      }
    });
    this.selectedUnit = unit;
    this.measurementsDataService.setData(this.selectedUnit.value);
  }

  saveMeasurementsUnit() {
    if (this.userData?.id) {
      this.userService.updateMeasurementsProfile(this.userData?.id, this.selectedUnit.value).subscribe({next: () => {
          this.gettingUserProfileData();
          this.toastr.success('Profile Measurements Updated');
          this.naviagteToHomePage();
        }, error: error => {
      }});
    }
  }
  naviagteToHomePage(){
    this.router.navigate(['/']);
  }
}
